import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "users" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_tab = _resolveComponent("md-tab")!
  const _component_md_tabs = _resolveComponent("md-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_md_tabs, { title: "Training" }, {
      default: _withCtx(() => [
        _createVNode(_component_md_tab, {
          title: "Modelle",
          icon: "model_training",
          name: "BotTrainingModels"
        }),
        _createVNode(_component_md_tab, {
          title: "Trainingsdaten",
          icon: "text_snippet",
          name: "BotTrainingTrainingsData"
        })
      ]),
      _: 1
    })
  ]))
}